'use client';

import { useEffect, useState } from 'react';

export function Reveal({
  children,
  delay = 0,
  className,
  as = 'div',
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'section' | 'li' | 'span';
}) {
  const [MotionReveal, setMotionReveal] = useState<typeof import('./reveal-motion').MotionReveal | null>(null);

  useEffect(() => {
    import('./reveal-motion').then((mod) => setMotionReveal(() => mod.MotionReveal));
  }, []);

  if (!MotionReveal) {
    const Tag = as;
    return <Tag className={className}>{children}</Tag>;
  }

  return (
    <MotionReveal delay={delay} className={className} as={as}>
      {children}
    </MotionReveal>
  );
}
